
export function modPow(base: bigint, exp: bigint, mod: bigint): bigint {
  let result = 1n;
  base = base % mod;
  while (exp > 0n) {
    if (exp % 2n === 1n) result = (result * base) % mod;
    base = (base * base) % mod;
    exp = exp / 2n;
  }
  return result;
}

export function millerRabin(n: bigint, k = 5): boolean {
  if (n === 2n || n === 3n) return true;
  if (n < 2n || n % 2n === 0n) return false;
  let r = 0n, d = n - 1n;
  while (d % 2n === 0n) { d /= 2n; r += 1n; }
  TestLoop:
  for (let i = 0; i < k; i++) {
    const a = 2n + BigInt(Math.floor(Math.random() * Number(n - 4n)));
    let x = modPow(a, d, n);
    if (x === 1n || x === n - 1n) continue;
    for (let j = 0n; j < r - 1n; j++) {
      x = modPow(x, 2n, n);
      if (x === n - 1n) continue TestLoop;
    }
    return false;
  }
  return true;
}

export function randomBigIntInRange(min: bigint, max: bigint): bigint {
  const range = max - min;
  let rand = BigInt(Math.floor(Math.random() * Number(range))) + min;
  if (rand % 2n === 0n) rand += 1n;
  return rand;
}

export async function randomPrimeInRange(min: bigint, max: bigint): Promise<bigint> {
  let candidate: bigint;
  do {
    candidate = randomBigIntInRange(min, max);
  } while (!millerRabin(candidate, 6));
  return candidate;
}

export function getLevelRange(level: number): [bigint, bigint] {
  if (level === 1) return [10n, 100n];
  if (level === 2) return [100n, 300n];
  if (level === 3) return [300n, 700n];
  if (level === 4) return [700n, 2000n];
  if (level === 5) return [2000n, 5000n];
  if (level <= 7) return [5000n, 15000n];
  if (level <= 10) return [15000n, 80000n];
  if (level <= 15) return [80000n, 250000n];
  if (level <= 20) return [250000n, 800000n];
  const min = BigInt(Math.floor(2_000_000 * Math.pow(level - 15, 1.4)));
  return [min, min + 2_000_000n];
}

export async function getLevelPrimes(level: number): Promise<[bigint, bigint, bigint]> {
  const [min, max] = getLevelRange(level);
  let p = await randomPrimeInRange(min, max);
  let q;
  do {
    q = await randomPrimeInRange(min, max);
  } while (q === p);
  return [p, q, p * q];
}

export function generateFibsUpTo(max: bigint): bigint[] {
  const fibs = [1n, 2n];
  while (fibs[fibs.length - 1] < max) {
    fibs.push(fibs[fibs.length - 1] + fibs[fibs.length - 2]);
  }
  return fibs;
}

export function hasAdjacent(arr: boolean[]): boolean {
  for (let i = 1; i < arr.length; ++i) if (arr[i] && arr[i - 1]) return true;
  return false;
}

export function sumSelected(arr: boolean[], fibs: bigint[]): bigint {
  return arr.reduce((acc, v, i) => acc + (v && typeof fibs[i] === "bigint" ? fibs[i] : 0n), 0n);
}
